<script>
import DibbleAPI from "../../../api";
import DibbleJS from "../../../dibble";
import UpComingEvents from "../../Boat/UpComingEvents.vue";

export default {
  name: "RentalMap",
  display: "Transition",
  components: {UpComingEvents},
  data() {
    return {
      dibbleJs: DibbleJS,
      mapInfo: null,
      interval: null,
      initialMapCenter: null,
      isRequesting: false,
      markerOptions: {
        url: require("../../../assets/images/boat_map_icon.png"),
      },
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -45,
        },
      },
      polygons: [],
    };
  },
  created() {
    this.getRentalMapInfo();
    this.getRestrictionMapsInfo();
  },
  mounted() {

  },
  methods: {
    getRentalMapInfo() {
      const params = {
        request: DibbleAPI.api.getRentalMapInfo,
      };
      this.dibbleJs.callApiRequest(params, (response) => {
        if (DibbleAPI.isResponseSuccess(response)) {
          this.handleGetRentalMapInfoApiResponse(response)
          if (response.refresh_secs && !this.interval) {
            this.interval = setInterval(() => {
              if (!this.isRequesting) {
                  this.isRequesting = true;
                  this.dibbleJs.callApiRequest(params, (response2) => {
                      if (DibbleAPI.isResponseSuccess(response2)) {
                          this.handleGetRentalMapInfoApiResponse(response2)
                      }
                      this.isRequesting = false;
                  })
              }
            }, response.refresh_secs * 1000)
          }
        }
      });
    },
    handleGetRentalMapInfoApiResponse(response) {
      if (!this.initialMapCenter) {
        this.initialMapCenter = {
            lat: response.center_lat,
            lng: response.center_lon
        }
      }

      this.mapInfo = response;
      this.mapInfo.boats.forEach(boat => {
        boat.position = {lat: boat.lat, lng: boat.lon}
      })
    },
    getInfoWindowContent: function (boat) {
      const extraClass = (boat.is_restricted ? "restricted" : "") + (boat.missing_alert ? " missing" : "");
      return `
            <div class="card border-0">
                <div class="card-content map-info-popup ${extraClass}">
                    <div class="media">
                        <div class="media-content">
                            <p class="title is-4">${boat.name}</p>
                        </div>
                    </div>
                    <div class="content">
                        ${boat.boat_type}
                    </div>
                </div>
            </div>`;
    },
    openOrder(orderId) {
      this.$router.push(`/rental-order/${orderId}`)
    },
    getRestrictionMapsInfo () {
      const params = {
        request: DibbleAPI.api.getRestrictionMapsInfo,
        token: DibbleJS.getStorageToken()
      };
      this.dibbleJs.callApiRequest(params, (response) => {
          if (DibbleAPI.isResponseSuccess(response)) {
            if (response.polygons && response.polygons.length) {
              this.polygons = response.polygons.map(eachPolygon => {
                eachPolygon = eachPolygon.map(item => {
                  return {
                    lng: item[0],
                    lat: item[1]
                  }
                })
                return eachPolygon
              })
            }
          }
      })
    }
  },
};
</script>
<template>
  <div id="content" class="sidebar-bg w-l d-md-flex justify-content-between" v-if="mapInfo">
    <GmapMap
      :center="{ lat: initialMapCenter.lat, lng: initialMapCenter.lng }"
      :zoom="mapInfo.map_zoom"
      map-type-id="hybrid"
      :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
            }"
      class="w-100"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="boat.position"
        v-for="(boat, index) in mapInfo.boats"
        :class="'wapper'"
        :key="index + 100"
      >
        <div v-html="getInfoWindowContent(boat)"></div>
      </gmap-info-window>
      <GmapMarker
        :key="index"
        v-for="(boat, index) in mapInfo.boats"
        :position="boat.position"
        :clickable="true"
        :draggable="false"
        :icon="{url: boat.icon_url}"
        :title="boat.name"
        @click="openOrder(boat.order_id)"
      >
        <div>icon</div>
      </GmapMarker>
      <gmap-polygon :paths="polygons" :options="{ strokeWeight:'1', strokeColor: '#EF1821', fillColor: '#EF1821', fillOpacity: '0.35'}">
      </gmap-polygon>
    </GmapMap>
    <div class="sidebar v-mob" style="height: calc(100vh - 75px);">
      <div class="sidebar w-mob">
        <UpComingEvents :boatType="0"/>
      </div>
    </div>
  </div>
</template>
<style lang="css">
.gm-style-iw button {
  display: none !important;
}

.gm-style .gm-style-iw-c, .map-info-popup {
  background: #FFFFFF;
    padding: 10px;
}
.gm-style .gm-style-iw-c, .map-info-popup.restricted {
  background: #f20229;

}
.gm-style .gm-style-iw-c, .map-info-popup.missing {
  background: #f5ec00;
}

.gm-style .gm-style-iw-d::-webkit-scrollbar-track,
.gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece,
.gm-style .gm-style-iw-c,
.gm-style .gm-style-iw-t::after {
  background: #FFFFFF;
}

.map-info-popup {
  font-weight: 700;
  min-width: 150px;
  font-size: 16px;
}
</style>
